<div [formGroup]="billingTermsForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.billingFrequency">支払い詳細</span>
  </div>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label i18n="@@adminSystem.distributorDetails.label.billingFrequency">頻度</mat-label>
    <mat-select formControlName="billingFrequency">
      @for (item of billingFrequency; track item) {
        <mat-option [value]="item.code">{{ item.desc }}</mat-option>
      }
    </mat-select>
    @if (billingTermsForm.get('billingFrequency')?.hasError('required')) {
      <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
    }
  </mat-form-field>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.billingCycleAnchorMonth">締め月</mat-label>
      <input matInput formControlName="billingCycleAnchorMonth" />
      @if (billingTermsForm.get('billingCycleAnchorMonth')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.billingCycleAnchorDay">締め日</mat-label>
      <input matInput formControlName="billingCycleAnchorDay" />
      @if (billingTermsForm.get('billingCycleAnchorDay')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.paymentTermsMonths">支払い条件 月</mat-label>
      <input matInput formControlName="paymentTermsMonths" />
      @if (billingTermsForm.get('paymentTermsMonths')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.paymentTermsDays">支払い条件 日</mat-label>
      <input matInput formControlName="paymentTermsDays" />
      @if (billingTermsForm.get('paymentTermsDays')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label i18n="@@adminSystem.distributorDetails.label.pricingModel">料金モデル</mat-label>
      <mat-select formControlName="pricingModel">
        @for (item of pricingModel; track item) {
          <mat-option [value]="item.code">{{ item.desc }}</mat-option>
        }
      </mat-select>
      @if (billingTermsForm.get('pricingModel')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.currency">支払い通貨</mat-label>
      <input matInput formControlName="currency" />            
      @if (billingTermsForm.get('currency')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label i18n="@@adminSystem.distributorDetails.label.basePrice">固定料金</mat-label>
      <input matInput formControlName="basePrice" />
      @if (billingTermsForm.get('basePrice')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.unitPrice">従量料金</mat-label>
      <input matInput formControlName="unitPrice" />            
      @if (billingTermsForm.get('unitPrice')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>
</div>